import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { getAddressLookup } from '../../requests/get_address_lookup_request';
import { addDataByStreetRequestSuccess, addDataByStreetRequestFailure } from '../actions/address_lookup.actions';
import { ADD_DATA_BY_STREET_REQUEST } from '../constants/address_lookup.constants';
import { message_error } from '../../../../../components/Message';
import { searchByCounties } from '../../requests/search_by_counties_request';
import { searchLeadCountyRequestSuccess } from '../actions/search_lead_county.actions';
import { createNewCounty } from '../../../Lead_create/requests/create_new_county_request';
import {
    createNewCountyFailure,
    createNewCountySuccess,
} from '../../../Lead_create/redux/actions/create_new_county.actions';

function* addDataByStreetsRequest({ data }) {
    let d;

    try {
        const result = yield call(getAddressLookup, data);
        const { county } = result;

        if (county) {
            const searched = yield call(searchByCounties, county);

            if (result && Array.isArray(searched.options)) {
                d = yield put(searchLeadCountyRequestSuccess(searched.options[0]));
            }
        }

        const { payload } = yield put(addDataByStreetRequestSuccess(result));

        if (county && d?.payload === null) {
            const { result: createResult, options, error } = yield call(createNewCounty, { name: payload.county });
            if (createResult) {
                yield put(createNewCountySuccess(options));
                message.success(`County ${options.name} successfully created`);
            } else {
                yield put(createNewCountyFailure(error.errmsg || error));
                message.error(error.errmsg || 'Something went wrong, try again, please');
            }
        }
    } catch (error) {
        yield put(addDataByStreetRequestFailure(error));
        message_error('Something gone wrong!');
    }
}

export default function* addDataByStreetsSaga() {
    yield takeEvery(ADD_DATA_BY_STREET_REQUEST, addDataByStreetsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/add_data_by_streets.saga.js